<template>
  <div
    class="rainshutdown"
    :class="{'rainshutdown--wheel': wheelState}"
  >
    <div
      v-if="!computedShowRainShutdown"
      class="wheel__pause"
      disabled
    />
    <div
      v-else
      class="wheel__pause"
      :class="{'page-pause': rainShutDownStarted}"
      @click.stop="shutDownClick()"
    >
      <div
        v-if="showRainShutDownSpinner === 'showStarter' || showRainShutDownSpinner === 'showStopper' || rainShutDownStarted"
        class="wheel__pause__spinner"
      />
      <div
        class="front"
        :class="{'front--disabled': computedIsInAutomaticMode}"
        :title="computedIsInAutomaticMode ? $t('messages.rainShutDown.unavailable') : $t('messages.rainShutDown.available')"
      >
        {{ $t('messages.sharedTexts.rainShutdown') }}
      </div>
      <div class="back">
        <slot v-if="rainShutDownStarted">
          <h6 class="rainshutdown__title">
            {{ $t('messages.sharedTexts.rainShutdown') }}
          </h6>
          <p class="rainshutdown__countdown">
            {{ NicefyClock(rainShutDown) }}
          </p>
          <p
            v-if="rainShutDownStarted"
            class="rainshutdown__resume"
          >
            <font-awesome-icon :icon="['fas', 'play']" /> {{ $t('messages.sharedTexts.controls.resume') }}
          </p>
        </slot>
        <p v-else>
          {{ NicefyClock(0) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {
  FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'

export default {
  name: 'RainShutDownControl',
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  props: {
    controllerMode: {
      type: Number,
      default: null
    },
    controllerGroup: {
      type: String,
      default: null
    },
    rainShutDown: {
      type: Number,
      default: null
    },
    rainShutDownStarted: {
      type: Boolean,
      default: false
    },
    wheelState: {
      type: Boolean,
      default: false
    },
    showRainShutDownSpinner: {
      type: String,
      default: null
    },
    PageMessage: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    computedIsInAutomaticMode() {
      return this.controllerMode !== 2
    },
    computedShowRainShutdown() {
      return this.controllerGroup && this.controllerGroup !== 'TWC'
    }
  },
  mounted() {},
  methods: {
    SetPageMessage(Message) {
      this.$emit('SetPageMessage', Message)
    },
    shutDownClick() {
      if(this.controllerMode === 2 && this.controllerGroup !== 'TWC') {
        this.$emit('SetPageMessage', {
          target: 'ShowModal',
          modalData: {
            component: 'RainShutDown',
            data: {
              RemainHours: 0,
              RemainDays: 0
            }
          }
        })
      }
    },
    NicefyClock(sec) {
      if(sec <= 0) {
        return'00d 00:00'
      } else {
        var start = (sec)
        var day = Math.floor(start / 86400)
        var left = start - (day * 86400)
        var hour = Math.floor(left / 3600)
        this.RemainHours = Math.round(left / 3600)
        left = start - ((hour * 3600) + (day * 86400))
        var min = Math.floor(left / 60)

        left = left - (min * 60)
        sec = Math.floor(left / 1)
        day = (day < 10) ? ('0' + day) : day
        hour = (hour < 10) ? ('0' + hour) : hour
        min = (min < 10) ? ('0' + min) : min
        sec = (sec < 10) ? ('0' + sec) : sec
        this.RemainDays = day
        return day + 'd ' + hour + ':' + min + ':' + sec
      }
    }
  }
}
</script>

<style lang="scss">
.rainshutdown {
  z-index: 1;
  border: 5px solid white;
  border-radius: 50%;
  color: lighten($font-primary-color, 20);

  &__title {
    margin: 5px;
  }
  &__countdown {
    font-family: monospace, monospace;
  }
  &__resume {
    padding-top: 10px;
    font-size: 14px;
  }
  &--wheel {
    border: 0 !important; // @TODO: NO !important

    .wheel__pause {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%,-50%,0);
      z-index: $z-ui+1;
      padding-top: 20% !important; // @TODO: NO !important
      width: 20% !important; // @TODO: NO !important
      background: $color-grey !important; // @TODO: NO !important

      &.page-pause {
        transform: translate3d(-50%,-50%,0) rotateY(180deg) !important; // Lift up or it will clip @TODO: NO !important
      }

      .front {
        background: $color-grey !important; // @TODO: NO !important
        color: lighten($font-primary-color, 20) !important; // @TODO: NO !important
        
        &--disabled {
          color: lighten($color-grey, 5) !important;
        }
      }
    }
  }

  .wheel__pause {
    @include hardware-accelerate(false);
    padding-top: 110px;
    width: 110px;

    transition: transform 1s ease-in-out;
    transform-origin: center;
    cursor: pointer;
    border-radius: 50%;
    transform-style: preserve-3d;

    .rainshutdown.rainshutdown--wheel & {
      background: $color-red !important;
    }

    &.page-pause {
      transform: rotateY(180deg); // Lift up or it will clip
    }

    .front, .back {
      @include hardware-accelerate(false);
      $size: 0; // % smaller than 100%
      backface-visibility: hidden;
      position: absolute;
      font-size: 15px;
      font-family: $font-primary-semibold;
      text-transform: uppercase;
      letter-spacing: -0.5px;
      top: $size;
      right: $size;
      bottom: $size;
      left: $size;
      transform-style: preserve-3d;
    }

    .front {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-family: $font-primary;
      font-size: 11px;
      line-height: 12px;
      border-radius: 50%;
      background: $color-blue-marine;
      color: $color-white;

      &--disabled {
        background: $color-grey;
        color: lighten($color-grey, 5);
      }
    }

    &__spinner {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      @include spinner('after', calc(100% + 10px), 5px, $color-blue-marine);

      &:after {
        box-sizing: border-box;
        margin: -5px;
      }
    }

    .back {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      justify-content: center;
      transform: rotateY(180deg);
      -webkit-transform: rotateY(-180deg);

      font-size: 15px;
      font-family: $font-primary-semibold;
      text-transform: uppercase;
      letter-spacing: -0.5px;

      p {
        margin: 0px;
      }
    }
  }
}

@media screen and (min-width: $bp-tablet - 1) {
  .rainshutdown {
    .wheel__pause {
      .front {
        font-size: 16px;
        line-height: 19px;
      }
    }
  }
}
</style>
